module.exports = __webpack_public_path__ + "static/img/thumb.19307eb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/use-case/thumb.png
// module id = tX8K
// module chunks = 0